import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import { Checkbox, Tooltip } from "antd";
import { translateKey as t } from "../../../locales/translation";
import _ from "lodash";

const RenderCheckBox = observer(
  ({ row, selectAll, controller }: { row?: any; selectAll?: boolean; controller: OFTableController }) => {
    const indeterminateState = () => {
      let indeterminate = false;

      if (
        selectAll &&
        controller.multiSelectedRows.totSelected > 0 &&
        controller.multiSelectedRows.totSelected !== controller.sortedFilteredList.length
      ) {
        indeterminate = true;
      }

      return indeterminate;
    };

    const checkedState = () => {
      let checked = false;

      // If selected/unselected all
      if (selectAll && controller.multiSelectedRows.totSelected > 0) {
        checked = controller.multiSelectedRows.totSelected === controller.sortedFilteredList.length;
      }
      // Single row check
      else {
        checked = controller.multiSelectedRows.rows[_.get(row, "_id", null)] ? true : false;
      }

      return checked;
    };

    const checkboxState = () => {
      if (controller.maxSelectAllCount) {
        return selectAll && controller.sortedFilteredList.length > controller.maxSelectAllCount;
      }

      return false;
    };

    const getTooltipTitle = () => {
      const { maxSelectAllCount } = controller;

      if (checkboxState()) {
        return t("lblItemLimitExceededCount", "Item Limit Exceeded ({1})", [maxSelectAllCount]);
      }

      return null;
    };

    if (checkboxState()) {
      return (
        <Tooltip title={getTooltipTitle} placement="right">
          <Checkbox
            onChange={(e) => controller.multiselectRows(row, e.target.checked, selectAll)}
            indeterminate={indeterminateState()}
            checked={checkedState()}
            disabled={checkboxState()}
          />
        </Tooltip>
      );
    } else {
      return (
        <Checkbox
          onChange={(e) => controller.multiselectRows(row, e.target.checked, selectAll)}
          indeterminate={indeterminateState()}
          checked={checkedState()}
          disabled={checkboxState()}
        />
      );
    }
  }
);

export { RenderCheckBox };
